import axios from 'axios'

import ApiError from './error'
import type { RequestHeaders, ResponseError } from './types'

const AxiosProvider = axios

export { AxiosProvider, ApiError }

export { whenRequestWithError, whenResponseWithError } from './interceptors'

export type { AxiosInstance as Instance, AxiosRequestConfig as RequestConfig } from 'axios'

export type { RequestHeaders, ResponseError }
